import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

export default function HomepageNewsGallery() {
  return (
    <Grid item xs={12}>
      <Typography component="h1" variant="h2" align="center" color="text.primary" gutterBottom>
        KnapsackLabs
      </Typography>
      <Typography variant="h5" align="center" color="text.secondary" paragraph>
        This site provides educational math and computer science lessons. This website is in its
        early stages. I will post news regarding the websites development here!
      </Typography>
    </Grid>
  );
}
